import {GET_SUPPORT_TICKETS} from "../../Config/ApiUrl";
import HelperMixin from "../../../common/Mixin/Global/HelperMixin";
import DatatableHelperMixin from "../../../common/Mixin/Global/DatatableHelperMixin";

export default {
    // mixins: [],
    mixins: [HelperMixin, DatatableHelperMixin],
    data() {
        function asset(path) {
            return `${window.location.origin}/${path}`;
        }
        return {
            isLocationModalActive: false,
            isLocationCreateOpenModalActive: false,
            selectedUrl: '',
            promptIcon: '',
            employeeId: '',
            modalClass: '',
            isModalActive: false,
            options: {
                showSearch: true,
                showFilter: true,
                // cardViewComponent: 'app-package-card-view',
                name: this.$allLabel('tickets'),
                url: GET_SUPPORT_TICKETS,
                showCount: true,
                showClearFilter: true,
                responsive: true,
                showAction: true,
                actionType: "default",
                enableRowSelect: false,
                columns: [
                    {
                        title: this.$t('title'),
                        type: 'custom-html',
                        key: 'title',
                        isVisible: true,
                        modifier: (title) => {
                            return title ? title: '-';
                        }
                    },
                    {
                        title: this.$t('description'),
                        type: 'custom-html',
                        key: 'description',
                        isVisible: true,
                        modifier: (description) => {
                            return description ? description: '-';
                        }
                    },
                    {
                        title: this.$t('category'),
                        type: 'custom-html',
                        key: 'category',
                        isVisible: true,
                        modifier: (category) => {
                            return category ?? '';
                        }
                    },
                    {
                        title: this.$t('user'),
                        type: 'custom-html',
                        key: 'user',
                        isVisible: this.$isAdmin(),
                        modifier: (user) => {
                            if (this.$isAdmin())
                                return user.full_name ?? "";
                            return "";
                        }
                    },
                    {
                        title: this.$t('image'),
                        type: 'custom-html',
                        key: 'image',
                        isVisible: true,
                        modifier: (image) => {
                            if (image)
                                return `<img src="${image}" alt="demo crm" style="max-width: 100px;"/>`;
                            else
                                return `<img src="${ asset('images/placeholder_img.png') }" alt="product placeholder" style="max-width: 100px;"/>`
                        }
                    },
                    {
                        title: this.$t('status'),
                        type: 'custom-html',
                        key: 'status',
                        isVisible: true,
                        modifier: status => {
                            // Define badge classes for different statuses
                            let badgeClass = '';
                            switch (status) {
                                case 'Pending':
                                    badgeClass = 'warning';
                                    break;
                                case 'Resolved':
                                    badgeClass = 'success';
                                    break;
                                case 'Rejected':
                                    badgeClass = 'danger';
                                    break;
                                default:
                                    badgeClass = 'secondary';
                            }

                            // Return the HTML for the badge
                            return `<span class="badge badge-pill text-capitalize badge-${badgeClass}">
                                ${this.$t(status)}
                            </span>`;
                        }
                    },
                    {
                        title: this.$t('actions'),
                        type: 'action'
                    }
                ],
                rowLimit: 10,
                paginationType: "pagination",
                actions: [
                    {
                        title: this.$t('edit'),
                        // url: GET_SUPPORT_TICKETS,
                        icon: 'edit',
                        key: "edit",
                        modifier: row => {
                            return this.$can('update_support_ticket') && (row.id !== window.user.id || this.$isAdmin() || this.$isTenantAdmin());
                        },
                    },
                    /*{
                        title: this.$t('delete'),
                        icon: 'trash-2',
                        url: GET_SUPPORT_TICKETS,
                        type: 'modal',
                        component: 'app-confirmation-modal',
                        modalId: 'app-confirmation-modal',
                        name: 'delete',
                        modifier: row => {
                            return this.$can('delete_crms') && (row.id !== window.user.id || this.$isAdmin() || this.$isTenantAdmin());
                        },
                    }*/
                ],
                filters: [
                    {
                        title: this.$t('created'),
                        type: "range-picker",
                        key: "created_at",
                        option: ["today", "thisMonth", "last7Days", "thisYear"]
                    },
                    {
                        title: this.$t('name'),
                        key: "name",
                        type: "text",
                    },
                ]
            },
            selectedEmployees: [],
            isContextMenuOpen: false,
        }
    },
    methods: {
        openLocationModal() {
            this.isLocationModalActive = true;
        },
        setFilterValues(filterValue) {
            if (filterValue.date_range && typeof filterValue.date_range != 'string') {
                filterValue.date_range = JSON.stringify(filterValue.date_range)
            }
            this.$store.dispatch('updateFilterObject', filterValue)
        },
        setSearchValue(search) {
            this.$store.dispatch('updateFilterObject', {search: search})
        },
        getSelectedRows(data, isSelectedAll) {
            this.selectedEmployees = data;
            this.isContextMenuOpen = data.length;
        },
        triggerActions(row, action, active) {


            // if (action.key === 'view_details') {
            //     window.location = urlGenerator(`${EMPLOYEES_PROFILE}/${this.employeeId}/profile`);
            // }

            if (action.key === 'edit') {
            }

        },
        reloadTicketTable() {
            this.isContextMenuOpen = false;
            this.$hub.$emit('reload-ticket-table')
        },
    }
}